import { Component } from 'react';
import PropTypes from 'prop-types';
import Accordion from '../Accordion';

export default class InfoAccordion extends Component {
  constructor(props) {
    super(props);

    this.descriptionRef = null;

    this.state = {
      activeAccordion: null,
    };
  }

  componentDidMount() {
    if (this.descriptionRef) this.setDescriptionContent();
  }

  handleClick(clickedAccordion) {
    const { activeAccordion } = this.state;
    const newValue =
      clickedAccordion === activeAccordion ? null : clickedAccordion;

    this.setState({ activeAccordion: newValue });
  }

  setDescriptionContent() {
    const { description } = this.props;
    this.descriptionRef.innerHTML = description;
  }

  render() {
    const { activeAccordion } = this.state;
    const { description, requirements } = this.props;

    return (
      <Accordion id="direct-sales-accordion" defaultActiveKey={activeAccordion}>
        {description && description.length ? (
          <div className="direct-sales__accordion">
            <Accordion.Toggle
              eventKey="description-info"
              onClick={() => this.handleClick('description-info')}
            >
              Descrição
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="description-info">
              <div
                // eslint-disable-next-line no-return-assign
                ref={node => (this.descriptionRef = node)}
                className="direct-sales__description"
              />
            </Accordion.Collapse>
          </div>
        ) : null}

        {requirements && requirements.length ? (
          <div className="direct-sales__accordion">
            <Accordion.Toggle
              eventKey="terms-and-conditions-info"
              onClick={() => this.handleClick('terms-and-conditions-info')}
            >
              Termos e condições
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="terms-and-conditions-info">
              <div className="direct-sales__terms-content">
                <div>
                  Para consultar as condições destas ofertas, baixe o documento:
                </div>
                <div className="button-container">
                  <a
                    className="btn button button--large button--primary"
                    href={requirements}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Baixar
                  </a>
                </div>
              </div>
            </Accordion.Collapse>
          </div>
        ) : null}
      </Accordion>
    );
  }
}

InfoAccordion.propTypes = {
  description: PropTypes.string,
  requirements: PropTypes.string,
};
